/**
 * Decide entre login e conteudo.
 *
 * Mais simples que o portao do NIG: aqui o login e SEMPRE obrigatorio - nao existe instalacao do
 * viewer sem autenticacao, e nao ha caminho de embed por token (o viewer e quem EMITE tokens, nao
 * quem os consome). Entao basta: com token, entra; sem token, tela de entrada.
 *
 * Sessao que expira no meio do uso volta para o login em vez de deixar a tela travada num erro.
 */

import { useEffect, useState, type ReactNode } from 'react'

import { getToken, UNAUTHORIZED_EVENT } from '../api/client'
import { LoginScreen } from './LoginScreen'

export function AuthGate({ children }: { children: ReactNode }) {
  const [token, setTokenState] = useState<string | null>(() => getToken())
  const [expirou, setExpirou] = useState(false)

  useEffect(() => {
    function aoPerderSessao() {
      setTokenState(null)
      setExpirou(true)
    }
    window.addEventListener(UNAUTHORIZED_EVENT, aoPerderSessao)
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, aoPerderSessao)
  }, [])

  if (token === null) {
    return (
      <LoginScreen
        notice={expirou ? 'Sua sessão expirou. Entre novamente.' : undefined}
        onEntered={() => {
          setTokenState(getToken())
          setExpirou(false)
        }}
      />
    )
  }
  return <>{children}</>
}
